import { useAuthState } from "react-admin";
import { Redirect } from "react-router";

export const DummyList = (props: any) => {
  const { loading, loaded, authenticated } = useAuthState();

  if (loading) {
    return <div>Loading</div>;
  }
  if (loaded) {
    if (authenticated) {
      return <Redirect to="/wordlists" />;
    } else {
      return <Redirect to="/login" />;
    }
  }
  return <div></div>;
};
